import { SWReactIcons } from '@similarweb/icons';
import { colorsPalettes } from '@similarweb/styles';

import { formatPercentage } from '../../../../services/numberFormat';

import { StyledAdNetworksChangeValue, StyledAdNetworksChangeUnavailable } from './styles';

export const ChangeValue: React.FC<{ change?: number }> = ({ change }) => {
  if (change === undefined) {
    return <StyledAdNetworksChangeUnavailable>N/A</StyledAdNetworksChangeUnavailable>;
  }

  const formattedValue = formatPercentage(Math.abs(change), 2);
  if (formattedValue === '0%') {
    return <span>{formattedValue}</span>;
  }

  const isPositive = change > 0;
  const iconName = isPositive ? 'arrow-up-grey' : 'arrow-down-grey';
  const iconColor = isPositive ? colorsPalettes.green.s100 : colorsPalettes.red.s100;

  return (
    <>
      <SWReactIcons iconName={iconName} size="xs" iconColor={iconColor} />
      <StyledAdNetworksChangeValue isPositive={isPositive}>{formattedValue}</StyledAdNetworksChangeValue>
    </>
  );
};
